module.exports = __webpack_public_path__ + "static/media/tutorial.1baa74f3.pdf";